module.exports = __webpack_public_path__ + "static/media/SearchIcon.6a56d2d1.svg";